import React from 'react'
import { Layout } from './common/layout'
import { Login } from './components/login'
import { AuthToken } from './services/auth'
import { Loading } from '@guillotinaweb/react-gmi'
import { Guillo } from './guillotina/guillotina'
import GuilloCfg from './guillotina/config'

import { AnalyticsPage } from './pages/analytics'
import { Customers } from './pages/customers'
import { ErpClientContext, ErpClient } from './services/erp'
import { Offers } from './pages/offers'
import { FreeShippingRatesPage } from './pages/free-shipping-rates'
import { OpinionsGroup } from './pages/opinions'
import { OrdersGroup } from './pages/orders'
import { ProductGroup } from './pages/product'
import { Router, Route, Switch } from 'wouter'
import { Users } from './pages/users'
import { InvoicesGroup } from './pages/invoices'
import { ContentAiGroup } from './pages/content_ai'
import { MarketPlaceGroup } from './pages/market_place'

import '@guillotinaweb/react-gmi/dist/css/style.css'
import './scss/styles.sass'

function App() {
  const auth = new AuthToken(GuilloCfg.url)
  const erpClient = new ErpClient(null, auth)
  const isLogged = auth.isLogged

  React.useEffect(() => {
    ;(async () => {
      await auth.ensureLogin()
    })()
  }, [isLogged])

  return (
    <Layout auth={auth}>
      {isLogged && (
        <Router base="/-admin">
          <ErpClientContext.Provider value={erpClient}>
            <Switch>
              <Route path="/orders/:rest*" component={OrdersGroup} />
              <Route path="/invoices/:rest*" component={InvoicesGroup} />
              <Route path="/product/:rest*" component={ProductGroup} />
              <Route path="/opinions/:rest*" component={OpinionsGroup} />
              <Route path="/analytics/:rest*" component={AnalyticsPage} />
              <Route path="/users/:rest*" component={Users} />
              <Route path="/market-place/:rest*" component={MarketPlaceGroup} />
              <Route path="/customers/:rest*" component={Customers} />
              <Route path="/offers/:rest*" component={Offers} />
              <Route path="/content_ai/:rest*" component={ContentAiGroup} />
              <Route
                path="/promos_trg/:rest*"
                component={FreeShippingRatesPage}
              />
              <Route path="/:rest*" component={() => <Guillo auth={auth} />} />
              {/* <Guillotina
                  client={client}
                  config={GuillotinaConfig.Cfg}
                  url={url}
                  registry={GuillotinaConfig.registry}
                /> */}
            </Switch>
          </ErpClientContext.Provider>
        </Router>
      )}
      {isLogged === false && (
        <div className="columns is-centered">
          <div className="columns is-half">
            <Login auth={auth} />
          </div>
        </div>
      )}
      {isLogged === undefined && <Loading />}
    </Layout>
  )
}

export default App
